exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-4a94b824] .v-dialog{position:relative\n}\n", ""]);

// exports
